export const DEFAULT_MEAL_LOG_DATA = {
  name: '',
  directions: '',
  number_of_servings: 1,
  is_active: undefined,
  servings_unit: 'cp',
  ingredients: [
    {
      name: '',
      sid: '',
      serving_size: '',
      serving_unit: '',
      color: '',
      itemresults_showing: false,
      itemresults: []
    },
  ],
};

export const FRIENDLY_UNITS = {
  teaspoon: 'Teaspoons',
  tablespoon: 'Tablespoons',
  cp: 'Cups',
  pt: 'Pints',
  qt: 'Quarts',
  gal: 'Gallons',
  floz: 'Ounces',
  g: 'Grams',
  lb: 'Pounds',
};